(function (module) {
    'use strict';
    let client = null;

    function onError(error, event, topic) {
        // Ignore ACK_TIMEOUT errors (handled by merge strategy)
        if (event === 'ACK_TIMEOUT') return;
        console.log(error, event, topic);
    }

    function ws(LoopBackAuth, envService, wsMergeStrategy) {

        if (client) return client;
        const { currentUserId: userId, accessTokenId: token, currentUserData: { email, accountId } } = LoopBackAuth;
        // WS.login({ userId, accountId, email }, token);

        const auth = {
            token,
            username: `accountId:${accountId}:user:${userId}`,
            principalType: 'ROCKET_UI',
        };

        const WS_URI = envService.read('WS_URI');

        // Create merge strategy to handle VERSION_EXISTS conflicts
        // Without this, data is LOST when concurrent updates occur
        const mergeStrategy = wsMergeStrategy.createMergeStrategy();

        const options = {
            reconnectIntervalIncrement: 1000,
            maxReconnectAttempts: Infinity,
            path: 'rocket',
            mergeStrategy: mergeStrategy,
        };
        const client = deepstream(WS_URI, options);
        console.log('WS merge strategy configured for conflict resolution');
        client.on('error', onError);
        client.login(auth, (success, data) => {
            // console.log('WS_CONNECTION:', { success, data });
        });

        // Helper function to set record data with metadata
        // Replaces WS.record.setData() to add _source and _timestamp for conflict resolution
        //
        // Usage:
        //   Single field: WS.record.setDataWithMetadata(recordName, 'fieldName', value, callback)
        //   Multiple fields: WS.record.setDataWithMetadata(recordName, { field1: value1, field2: value2 }, callback)
        //   Nested paths: WS.record.setDataWithMetadata(recordName, 'screenshot.large.enabled', true)
        client.record.setDataWithMetadata = function(recordName, fieldOrObject, valueOrCallback, callback) {
            const record = client.record.getRecord(recordName);
            const _ = window._; // Use global lodash (assumed available in rocket-ui)

            record.whenReady(() => {
                const current = record.get();
                const updates = _.cloneDeep(current); // Deep clone to avoid mutations

                // Add metadata
                updates._source = 'ui';
                updates._timestamp = Date.now();

                // Check if first argument is an object (multiple fields) or string (single field)
                if (typeof fieldOrObject === 'object' && fieldOrObject !== null) {
                    // Multiple fields mode: WS.record.setDataWithMetadata(recordName, { field1: val1, field2: val2 }, callback)
                    callback = valueOrCallback;

                    // Merge all field updates using lodash _.set for nested paths
                    for (const field in fieldOrObject) {
                        if (fieldOrObject.hasOwnProperty(field)) {
                            _.set(updates, field, fieldOrObject[field]);
                        }
                    }
                } else {
                    // Single field mode: WS.record.setDataWithMetadata(recordName, 'field', value, callback)
                    const field = fieldOrObject;
                    const value = valueOrCallback;
                    _.set(updates, field, value);
                }

                // Write without ACK callback to avoid deepstream.io-client-js v2.x crash bug
                // The bug: _handleWriteAcknowledgements crashes when message.data[2] is undefined
                // The write happens regardless of callback, and the callback only provided error logging
                record.set(updates);
                // Call user callback without error (write succeeded if no exception)
                if (callback) callback(null);
                // Small delay before discarding to ensure update completes
                setTimeout(() => record.discard(), 100);
            });
        };

        return client;
    }

    module.service('WS', ws);

})(angular.module('rocket.components'));
